import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgLoginOpened32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M15.894 2c4.902 0 7.299 3.093 7.094 9.025C25.192 11.24 27 12.9 27 14.898v11.216C27 28.257 24.92 30 22.5 30h-13C7.08 30 5 28.257 5 26.114V14.886C5 12.743 7.08 11 9.5 11h12.478c.194-5.382-1.802-7.947-6.084-7.947-3.557 0-5.316 1.311-5.892 4.595a.507.507 0 0 1-.587.423.525.525 0 0 1-.407-.613C9.678 3.64 11.878 2 15.894 2M22.5 12h-13C7.58 12 6 13.351 6 14.886v11.228C6 27.649 7.58 29 9.5 29h13c1.92 0 3.5-1.351 3.5-2.886V14.898C26 13.36 24.417 12 22.5 12M16 17a2 2 0 0 1 2 2v4a2 2 0 1 1-4 0v-4a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1" className="login-opened-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgLoginOpened32);
export default Memo;